// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_btn__ylOw4 {
    background: #fff;
    border: 1px solid var(--primary-color);
    padding: 4.5px;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0;
    position: relative;
    --icon-color-custom: var(--primary-color);
    transition:
        background-color 0.4s,
        border-color 0.4s;
}

/*.btn span {*/
/*    width: 80%;*/
/*    height: 80%;*/
/*}*/

.styles_btn__ylOw4 svg {
    width: 100%;
    height: 100%;
}

.styles_btn__ylOw4.styles_sm__nU389 {
    width: 20px;
    height: 20px;
    border-width: 1px;
    padding: 0;
}

.styles_btn__ylOw4.styles_sm__nU389 svg {
    width: 10px;
    height: 10px;
}

.styles_btn__ylOw4.styles_sm__nU389:before,
.styles_btn__ylOw4.styles_sm__nU389:after {
    height: 14px;
    width: 0.5px;
}

.styles_btn__ylOw4:hover {
    --icon-color-custom: #fff;
    background: var(--primary-color-active);
    border-color: var(--primary-color-active);
}
`, "",{"version":3,"sources":["webpack://./src/components/DeleteButton/styles.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC;;yBAEqB;AACzB;;AAEA,cAAc;AACd,kBAAkB;AAClB,mBAAmB;AACnB,IAAI;;AAEJ;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,yCAAyC;AAC7C","sourcesContent":[".btn {\n    background: #fff;\n    border: 1px solid var(--primary-color);\n    padding: 4.5px;\n    width: 34px;\n    height: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto 0;\n    position: relative;\n    --icon-color-custom: var(--primary-color);\n    transition:\n        background-color 0.4s,\n        border-color 0.4s;\n}\n\n/*.btn span {*/\n/*    width: 80%;*/\n/*    height: 80%;*/\n/*}*/\n\n.btn svg {\n    width: 100%;\n    height: 100%;\n}\n\n.btn.sm {\n    width: 20px;\n    height: 20px;\n    border-width: 1px;\n    padding: 0;\n}\n\n.btn.sm svg {\n    width: 10px;\n    height: 10px;\n}\n\n.btn.sm:before,\n.btn.sm:after {\n    height: 14px;\n    width: 0.5px;\n}\n\n.btn:hover {\n    --icon-color-custom: #fff;\n    background: var(--primary-color-active);\n    border-color: var(--primary-color-active);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `styles_btn__ylOw4`,
	"sm": `styles_sm__nU389`
};
export default ___CSS_LOADER_EXPORT___;
